import { render } from "./SingleFeedback.vue?vue&type=template&id=206a9da4&scoped=true"
import script from "./SingleFeedback.vue?vue&type=script&lang=js"
export * from "./SingleFeedback.vue?vue&type=script&lang=js"

import "./SingleFeedback.vue?vue&type=style&index=0&id=206a9da4&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-206a9da4"]])

export default __exports__